import "../style/Home.scss"
import {
	ContactSection,
	PageLanding,
	ProjectsList,
	SectionsList,
} from "../components"
import { useSelector } from "react-redux"
import { getProjects, getServices } from "../redux"
import { getText } from "../redux"
import { Helmet } from "react-helmet"

function Home() {
	const projects = useSelector(getProjects)
	const services = useSelector(getServices)
	const sectionData = useSelector(state => getText(state, "video"))
	const sectionData2 = useSelector(state => getText(state, "portfolio"))

	return (
		<div className="home">
			<Helmet>
				<title>
					Agentie de Web Design | Dezvoltare Aplicatii Mobile - Xposed Agency
				</title>
				<meta
					name="description"
					content="Agentie de Web Design | Dezvoltare Aplicatii Mobile - Xposed Agency"
				/>
			</Helmet>

			<PageLanding
				src={sectionData.src}
				title={sectionData.title}
				description={sectionData.description}
				isVideo
			/>

			<ProjectsList projects={projects} sectionData={sectionData2} />

			<ContactSection />

			<SectionsList isAspectRatio services={services} type="services" />
		</div>
	)
}

export default Home
